import { ReactComponent as Logo } from "../../../../images/icons/logoText.svg";
import LogoImg from "../../../../images/hero-img/straus2x.png";
import { NavLink } from "react-router-dom";
import React from "react";
import {AmplitudeEvent, logEvent} from "../../../utils/amplitude";

export const LogoComponent = () => {
    const navLinkClick = (to:string) => () => {
        logEvent(AmplitudeEvent.NAVIGATION_CLICK, {type: "home", to});
    };
    return <NavLink to="/" onClick={navLinkClick("/")}>
        <div className="flex items-center">
            <img src={LogoImg} alt="Easy Improv logo" className="w-[35px] h-[35px] mr-[10px]"/>
            <Logo />
        </div>
    </NavLink>;
};
